import { render, staticRenderFns } from "./MaterialGridItem.vue?vue&type=template&id=78d96208&scoped=true"
import script from "./MaterialGridItem.vue?vue&type=script&lang=js"
export * from "./MaterialGridItem.vue?vue&type=script&lang=js"
import style0 from "./MaterialGridItem.vue?vue&type=style&index=0&id=78d96208&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d96208",
  null
  
)

export default component.exports